var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { RowLayout } from '../row-layout';
import { styled } from '../styled';
import { bannerComponentName } from './banner-classes';
export var Root = styled('div', { name: bannerComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme;
    return ({
        borderBottom: "1px solid ".concat(theme.tokens.color_border_default),
        padding: "".concat(theme.spacing(3), " ").concat(theme.spacing(0)),
    });
});
var Content = styled(RowLayout, {
    name: bannerComponentName,
    slot: 'Content',
})(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return ({
        flexGrow: ownerState.fullWidth ? 1 : 'auto',
        alignItems: 'center',
        padding: theme.spacing(0, ownerState.padding || 5),
        flexWrap: 'nowrap',
        justifyContent: ownerState.center ? 'center' : 'space-between',
        gridTemplateRows: "minmax(".concat(theme.spacing(7), ", auto)"),
    });
});
export var Banner = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.center, center = _b === void 0 ? false : _b, _c = _a.padding, padding = _c === void 0 ? 5 : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, rootProps = __rest(_a, ["children", "center", "padding", "fullWidth"]);
    return (React.createElement(Root, __assign({ ref: ref }, rootProps),
        React.createElement(Content, { ownerState: { center: center, padding: padding, fullWidth: fullWidth } }, children)));
});
